import campaignsJson from './fixtures/campaigns.json'
import adsJson from './fixtures/w2/ads.json'
import { initialCreatives } from './creatives'
import type { Ad, AdStatus, Campaign } from './types'

interface RawAd {
  id: string
  campaignId: string
  name: string
  creative: string
  status: AdStatus
  spend: number
  orders: number
  impressions: number
  clicks: number
  reach: number
}

interface AdsFixture {
  items: RawAd[]
  accountCtr: number
}

interface CampaignFixture {
  campaigns: Campaign[]
}

const fixture = adsJson as unknown as AdsFixture
const campaigns = (campaignsJson as unknown as CampaignFixture).campaigns
const creativeIdByName = new Map(initialCreatives.map((creative) => [creative.name, creative.id]))

export const accountCtr = fixture.accountCtr

export const initialAds: Ad[] = fixture.items.map((ad) => {
  const creativeId = creativeIdByName.get(ad.creative)
  if (!creativeId) throw new Error(`广告 ${ad.id} 引用了未知素材 ${ad.creative}`)
  return {
    id: ad.id,
    campaignId: ad.campaignId,
    name: ad.name,
    creativeId,
    status: ad.status,
    spend: ad.spend,
    orders: ad.orders,
    impressions: ad.impressions,
    clicks: ad.clicks,
    reach: ad.reach,
  }
})

export function validateAdSums(ads: Ad[], campaignList: Campaign[], creativeList = initialCreatives): boolean {
  const currentCreativeById = new Map(creativeList.map((creative) => [creative.id, creative]))
  if (ads.length !== campaignList.reduce((total, campaign) => total + campaign.adCount, 0)) return false
  return campaignList.every((campaign) => {
    const items = ads.filter((ad) => ad.campaignId === campaign.id)
    if (items.length !== campaign.adCount) return false
    if (items.reduce((total, ad) => total + ad.spend, 0) !== campaign.spendMonth) return false
    if (items.reduce((total, ad) => total + ad.orders, 0) !== campaign.orders) return false
    if (items.reduce((total, ad) => total + ad.impressions, 0) !== campaign.impressions) return false
    return items.every((ad) => currentCreativeById.get(ad.creativeId)?.productId === campaign.productId)
  })
}

if (!validateAdSums(initialAds, campaigns)) {
  throw new Error('第二波广告夹具未通过条数、任务合计或素材商品一致性断言')
}

export function cloneInitialAds(): Ad[] {
  return structuredClone(initialAds)
}

export function createInitialSelectedByCampaign(): Record<string, string[]> {
  return initialAds.reduce<Record<string, string[]>>((result, ad) => {
    result[ad.campaignId] = [...(result[ad.campaignId] ?? []), ad.creativeId]
    return result
  }, {})
}
